/* ==========================================================================
   BV PERSO — Personnalisation produit (texte libre + envoi de fichier)
   Thème neutre de l'usine

   Contexte mesuré sur une boutique en production (2026-09-01) :
   - Thème Turbo, bouton d'ajout type="submit" dans un <form action="/cart/add">.
   - DEUX apps panier interceptent l'ajout : deux applications de panier.
     L'une d'elles ecoute le clic au niveau du DOCUMENT en capture et coupe la
     propagation -> un ecouteur pose sur le bouton n'est JAMAIS atteint.
   - Un bouton de paiement dynamique (Shop Pay) est present : il part droit au
     checkout, sans validation et sans pouvoir transporter de fichier.

   Trois parades, du plus sur au moins sur :
   1. VERROU : tant que la personnalisation obligatoire est incomplete, le
      bouton d'ajout est « disabled ». Un bouton desactive n'emet aucun clic :
      aucune app ne peut le detourner. C'est la garantie principale.
   2. GARDE : ecouteur de clic sur WINDOW en capture. La phase de capture part
      de window AVANT document : on passe donc avant elle.
   3. FICHIER : des qu'un fichier est joint, on soumet via form.submit(), qui
      n'emet PAS d'evenement submit et echappe donc a tous les handlers d'app.
      C'est le seul chemin qui garantit un POST multipart avec le fichier.
   Le bouton de paiement dynamique est masque sur les produits personnalisables.
   ========================================================================== */
(function () {
  'use strict';

  var MAX_BYTES = 20 * 1024 * 1024; /* limite Shopify pour /cart/add */
  var OK_EXT = ['png', 'jpg', 'jpeg', 'webp', 'gif', 'svg', 'pdf', 'heic', 'heif'];
  var registry = []; /* { root, form, validate, hasFile, showErr, focusFirstEmpty } */

  function humanSize(bytes) {
    if (bytes < 1024) return bytes + ' o';
    if (bytes < 1048576) return Math.round(bytes / 1024) + ' Ko';
    return (bytes / 1048576).toFixed(1).replace('.', ',') + ' Mo';
  }

  function extOf(name) {
    var i = String(name).lastIndexOf('.');
    return i === -1 ? '' : String(name).slice(i + 1).toLowerCase();
  }

  function init(root) {
    if (!root || root.getAttribute('data-bv-perso-ready') === '1') return;
    root.setAttribute('data-bv-perso-ready', '1');

    var form = root.closest ? root.closest('form') : null;
    if (!form) return;

    var textInput = root.querySelector('[data-bv-perso-text]');
    var fileInput = root.querySelector('[data-bv-perso-file]');
    var counter = root.querySelector('[data-bv-perso-count]');
    var counterWrap = root.querySelector('[data-bv-perso-countwrap]');
    var errBox = root.querySelector('[data-bv-perso-err]');
    var drop = root.querySelector('[data-bv-perso-drop]');
    var dropName = root.querySelector('[data-bv-perso-name]');
    var dropDefault = dropName ? dropName.textContent : '';
    var required = root.getAttribute('data-required') === 'true';

    form.setAttribute('enctype', 'multipart/form-data');
    /* Masque le bouton de paiement dynamique : il ne sait pas transporter de
       fichier et sauterait la validation. */
    form.classList.add('bv-perso-form');

    var addButtons = form.querySelectorAll('button[name="add"], input[name="add"]');
    var weDisabled = false;

    function hasFile() { return !!(fileInput && fileInput.files && fileInput.files.length); }

    function validate() {
      if (!required) return null;
      if (textInput && !textInput.value.trim()) {
        return 'Merci de renseigner votre personnalisation avant d’ajouter au panier.';
      }
      if (fileInput && !hasFile()) {
        return 'Merci de joindre votre visuel avant d’ajouter au panier.';
      }
      return null;
    }

    function showErr(msg) {
      if (!errBox) return;
      errBox.textContent = msg;
      errBox.classList.add('is-visible');
      root.classList.add('is-invalid');
    }

    function clearErr() {
      if (!errBox) return;
      errBox.classList.remove('is-visible');
      root.classList.remove('is-invalid');
    }

    /* ---------- VERROU (parade 1) ----------
       ATTENTION : ne JAMAIS surveiller ce bouton avec un MutationObserver.
       Mesure du 2026-09-01 : la barre d'ajout collante du thème (bv-sticky-atc)
       reagit aux changements d'etat du bouton, ce qui rebouclait sur l'observer
       et FIGEAIT le rendu de la page. Le verrou est donc reapplique uniquement
       sur des evenements utilisateur reels, plus une passe differee unique. */
    var gating = false;
    function applyGate() {
      if (!required || gating) return;
      gating = true;
      try {
        var invalid = !!validate();
        Array.prototype.forEach.call(addButtons, function (b) {
          if (invalid) {
            if (!b.disabled) { b.disabled = true; weDisabled = true; }
            if (b.getAttribute('aria-disabled') !== 'true') b.setAttribute('aria-disabled', 'true');
            b.classList.add('bv-perso-locked');
          } else if (weDisabled) {
            b.disabled = false;
            b.removeAttribute('aria-disabled');
            b.classList.remove('bv-perso-locked');
          }
        });
        if (!invalid) weDisabled = false;
        if (root.classList.contains('is-locked') !== invalid) {
          root.classList.toggle('is-locked', invalid);
        }
      } finally {
        gating = false;
      }
    }

    /* Le thème peut reactiver le bouton au changement de variante : une seule
       passe differee suffit a reposer le verrou, sans boucle possible. */
    if (required) {
      form.addEventListener('change', function () { setTimeout(applyGate, 0); });
      setTimeout(applyGate, 1500);
    }

    /* ---------- Compteur ---------- */
    function refreshCount() {
      if (!textInput || !counter) return;
      var max = parseInt(textInput.getAttribute('maxlength'), 10) || 0;
      counter.textContent = String(textInput.value.length);
      if (counterWrap) {
        if (max && textInput.value.length >= max) counterWrap.classList.add('is-full');
        else counterWrap.classList.remove('is-full');
      }
    }

    /* ---------- Fichier ---------- */
    function refreshFile() {
      if (!fileInput || !drop) return;
      var f = fileInput.files && fileInput.files[0];
      if (!f) {
        drop.classList.remove('is-filled');
        if (dropName) dropName.textContent = dropDefault;
        applyGate();
        return;
      }
      if (f.size > MAX_BYTES) {
        fileInput.value = '';
        drop.classList.remove('is-filled');
        if (dropName) dropName.textContent = dropDefault;
        showErr('Fichier trop lourd (' + humanSize(f.size) + '). Maximum accepte : 20 Mo.');
        applyGate();
        return;
      }
      if (OK_EXT.indexOf(extOf(f.name)) === -1) {
        fileInput.value = '';
        drop.classList.remove('is-filled');
        if (dropName) dropName.textContent = dropDefault;
        showErr('Format non accepte. Envoyez une image (JPG, PNG, WEBP, SVG) ou un PDF.');
        applyGate();
        return;
      }
      clearErr();
      drop.classList.add('is-filled');
      if (dropName) dropName.textContent = f.name + ' — ' + humanSize(f.size);
      applyGate();
    }

    if (textInput) {
      textInput.addEventListener('input', function () { refreshCount(); clearErr(); applyGate(); });
      refreshCount();
    }
    if (fileInput) {
      fileInput.addEventListener('change', refreshFile);
      refreshFile();
    }

    /* Glisser-deposer */
    if (drop && fileInput) {
      ['dragenter', 'dragover'].forEach(function (evt) {
        drop.addEventListener(evt, function (e) {
          e.preventDefault(); e.stopPropagation(); drop.classList.add('is-over');
        });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        drop.addEventListener(evt, function (e) {
          e.preventDefault(); e.stopPropagation(); drop.classList.remove('is-over');
        });
      });
      drop.addEventListener('drop', function (e) {
        var dt = e.dataTransfer;
        if (dt && dt.files && dt.files.length) {
          try { fileInput.files = dt.files; } catch (err) { return; }
          refreshFile();
        }
      });
    }

    function focusFirstEmpty() {
      try { root.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { root.scrollIntoView(); }
      if (textInput && !textInput.value.trim()) {
        try { textInput.focus({ preventScroll: true }); } catch (e) { textInput.focus(); }
      }
    }

    applyGate();

    registry.push({
      root: root, form: form, validate: validate, hasFile: hasFile,
      showErr: showErr, focusFirstEmpty: focusFirstEmpty
    });
  }

  /* ---------- GARDE (parade 2) : window, phase de capture ----------
     La capture part de window AVANT document : on passe donc avant les apps
     panier qui ecoutent sur document. */
  function windowGuard(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var trigger = t.closest('[name="add"], .add_to_cart, .ajax-submit, .shopify-payment-button');
    if (!trigger) return;

    var form = trigger.closest ? trigger.closest('form') : null;
    var entry = null;
    for (var i = 0; i < registry.length; i++) {
      if (registry[i].form === form || (form === null && registry[i].root.contains(trigger))) {
        entry = registry[i]; break;
      }
    }
    if (!entry) return;

    var msg = entry.validate();
    if (msg) {
      e.preventDefault();
      e.stopImmediatePropagation();
      entry.showErr(msg);
      entry.focusFirstEmpty();
      return false;
    }

    /* Fichier joint : seul un POST natif multipart le transporte. form.submit()
       n'emet pas d'evenement submit, donc aucune app ne peut le detourner. */
    if (entry.hasFile()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      entry.form.setAttribute('enctype', 'multipart/form-data');
      entry.form.submit();
      return false;
    }
  }

  window.addEventListener('click', windowGuard, true);
  window.addEventListener('submit', function (e) {
    var form = e.target;
    for (var i = 0; i < registry.length; i++) {
      if (registry[i].form !== form) continue;
      var msg = registry[i].validate();
      if (msg) {
        e.preventDefault();
        e.stopImmediatePropagation();
        registry[i].showErr(msg);
        registry[i].focusFirstEmpty();
        return false;
      }
    }
  }, true);

  function boot() {
    var nodes = document.querySelectorAll('[data-bv-perso]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('page:load', boot);
  document.addEventListener('shopify:section:load', boot);
  if (window.InstantClick && typeof window.InstantClick.on === 'function') {
    window.InstantClick.on('change', boot);
  }
})();
